import { FunctionComponent, useState } from "react"
import { Alert, Col, Container, Form, Row } from "react-bootstrap"
import Button from "react-bootstrap/Button"
import { useNavigate, useParams } from "react-router-dom"
import { Agreement, Plan, RouterExtended } from "../data/models"
import useLazyQuery from "../hooks/useLazyQuery"
import useQuery from "../hooks/useQuery"

interface IChangePlanPage {}
const ChangePlanPage: FunctionComponent<IChangePlanPage> = () => {
	const today = new Date().toISOString().substring(0, 10)
	const navigate = useNavigate()
	const params = useParams()
	const routerId = params.routerId
	const [plan, setPlan] = useState<Plan>()
	const [date, setDate] = useState<string>(today)
	const routerQuery = useQuery<void, RouterQueryResponse>(`${process.env.REACT_APP_KNIT_URL}routers?id=${routerId}`)
	const router = routerQuery.data?.routers?.[0]
	const plansQuery = useQuery<void, PlansQueryResponse>(`${process.env.REACT_APP_KNIT_URL}plans`)
	const changeCurrentAgreementUrl = `${process.env.REACT_APP_KNIT_URL}agreements/${router?.currentAgreementId}/change`
	const postAgreementChangeQuery = useLazyQuery<Partial<Agreement>, any>(changeCurrentAgreementUrl, "POST")
	//convert id to plan
	const setPlanId = (id: string) => {
		setPlan(plansQuery.data?.plans.find((p) => p.id === id))
	}
	//schedule start function
	const scheduleStart = async () => {
		await postAgreementChangeQuery.query({
			body: {
				planId: plan?.id,
				startDate: date,
			},
		})
		navigate(-1)
	}
	//
	const error = postAgreementChangeQuery.error || routerQuery.error
	//
	if (!routerQuery.data) {
		return (
			<Container style={{ maxWidth: 500 }}>
				<h2 className="text-center mt-4">Change Internet Plan</h2>
				<div className="text-center">Loading</div>
			</Container>
		)
	}
	return (
		<Container style={{ maxWidth: 500 }}>
			<h2 className="text-center mt-4">Change Internet Plan</h2>
			{error && <Alert variant={"warning"}>{error}</Alert>}
			<div className="text-center">
				Change internet plan for {router?.propertyName} {router?.unitName} with the following details?
			</div>
			<Form.Group className="mb-3" controlId="plan">
				<Form.Label>Plan</Form.Label>
				<Form.Select required value={plan?.id} onChange={(e) => setPlanId(e.target.value)}>
					<option></option>
					{plansQuery.data?.plans?.map((plan) => (
						<option key={plan.id} value={plan.id}>
							{plan.name}
						</option>
					))}
				</Form.Select>
			</Form.Group>
			<Form.Group className="mb-3" controlId="date">
				<Form.Label>First Day of Service for New Plan</Form.Label>
				<Form.Control type="date" required min={today} max={router?.currentEndDate} value={date} onChange={(e) => setDate(e.target.value)} />
			</Form.Group>
			<Row className="mt-4">
				<Col xs="auto">
					<Button variant="secondary" disabled={postAgreementChangeQuery.loading} onClick={() => navigate(-1)}>
						Cancel
					</Button>
				</Col>
				<Col></Col>
				<Col xs="auto">
					<Button variant="primary" disabled={postAgreementChangeQuery.loading || !!error || !plan || !date} onClick={scheduleStart}>
						{postAgreementChangeQuery.loading ? "Saving" : "Confirm"}
					</Button>
				</Col>
			</Row>
		</Container>
	)
}

export default ChangePlanPage

interface RouterQueryResponse {
	routers: RouterExtended[]
}
interface PlansQueryResponse {
	plans: Plan[]
}
